import { useEffect } from "react";
import {
  useSignal,
  viewport,
  expandViewport,
  swipeBehavior,
} from "@telegram-apps/sdk-react";

export function useTelegramScreen() {
  const expanded = useSignal(viewport.isExpanded);
  const fullscreen = useSignal(viewport.isFullscreen);

  useEffect(() => {
    if (expandViewport.isAvailable() && !expanded) {
      viewport.expand();
    }

    if (
      swipeBehavior.isSupported() &&
      swipeBehavior.disableVertical?.isAvailable?.()
    ) {
      swipeBehavior.disableVertical();
    }

    const fsAvailable = viewport.requestFullscreen?.isAvailable?.() === true;
    if (fsAvailable && !fullscreen) {
      viewport.requestFullscreen().catch(() => {});
    }
  }, [expanded, fullscreen]);
}
